import { DatePipe, NgForOf } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { BtwChartModule } from '@between/ng-cdk/chart';
import { Guid } from 'guid-typescript';
import { IIndicatorStorageDto } from 'src/app/api-services/indicator-api/indicator-api.interfaces';
import { AnalysisApiService } from 'src/app/api-services/analysis-api/analysis-api.service';
import { BtwCardModule } from '@between/ng-cdk/card';

@Component({
  selector: 'financial-statement-analysis',
  standalone: true,
  imports: [NgForOf, BtwChartModule, DatePipe, BtwCardModule],
  templateUrl: './financial-statement-analysis.component.html',
  styleUrl: './financial-statement-analysis.component.scss'
})
export class FinancialStatementAnalysisComponent implements OnInit {
  private readonly analysisApiService: AnalysisApiService = inject(AnalysisApiService);

  @Input({ required: true })
  analysisId!: Guid;

  series: string[] = [];
  dataSource: any[] | undefined;

  ngOnInit(): void {
    this.analysisApiService.getIndicatorPerAnalysisId('FinancialStatements', this.analysisId).subscribe({
      next: (response: IIndicatorStorageDto[]) => {
        this.setDataSource(response);
      }
    });
  }

  private setDataSource(data: IIndicatorStorageDto[]): void {
    this.series = data[0].specificIndicatorValues.map((i) => i.name);

    this.dataSource = data.map(item => Object.assign(
      { date: item.date }, 
      item.specificIndicatorValues.reduce((obj, item) => Object.assign(obj, { [item.name]: item.value }), {})));
  }
}
